import { removeToken } from '@/utils/token'
import { removeApplyId, removeJobCode } from '@/utils/resumeParams'

export default function removeInfo () {
  removeToken()
  removeApplyId()
  sessionStorage.removeItem('phone')
}
